import { BaseTool } from './BaseTool';
import { ToolType } from '../types';

export class EraserTool extends BaseTool {
  public id: ToolType = 'eraser';
  public name = 'Eraser Tool';
  public cursor = 'none';

  private isErasing = false;
  private lastX = 0;
  private lastY = 0;
  private currentMouseX = 0;
  private currentMouseY = 0;

  public onMouseDown(e: MouseEvent, canvasX: number, canvasY: number): void {
    const layer = this.editor.getActiveLayer();
    if (!layer || layer.locked || !layer.visible) return;

    this.isErasing = true;
    this.lastX = canvasX - layer.x;
    this.lastY = canvasY - layer.y;
    this.eraseDot(layer, this.lastX, this.lastY);
    this.editor.render();
  }

  public onMouseMove(e: MouseEvent, canvasX: number, canvasY: number): void {
    this.currentMouseX = canvasX;
    this.currentMouseY = canvasY;

    if (!this.isErasing) {
      this.editor.renderOverlayOnly();
      return;
    }

    const layer = this.editor.getActiveLayer();
    if (!layer || layer.locked || !layer.visible) return;

    const lx = canvasX - layer.x;
    const ly = canvasY - layer.y;

    this.eraseLine(layer, this.lastX, this.lastY, lx, ly);
    this.lastX = lx;
    this.lastY = ly;
    this.editor.render();
  }

  public onMouseUp(_e: MouseEvent): void {
    if (this.isErasing) {
      this.isErasing = false;
      this.editor.recordHistory('Eraser');
    }
  }

  private eraseDot(layer: any, x: number, y: number) {
    const settings = this.editor.toolSettings;
    const radius = settings.eraserSize / 2;
    const hardness = settings.eraserHardness / 100;

    layer.ctx.save();
    layer.ctx.globalCompositeOperation = 'destination-out';

    if (hardness >= 0.95) {
      layer.ctx.fillStyle = '#000000';
      layer.ctx.beginPath();
      layer.ctx.arc(x, y, radius, 0, Math.PI * 2);
      layer.ctx.fill();
    } else {
      const grad = layer.ctx.createRadialGradient(x, y, radius * hardness, x, y, radius);
      grad.addColorStop(0, 'rgba(0,0,0,1)');
      grad.addColorStop(1, 'rgba(0,0,0,0)');
      layer.ctx.fillStyle = grad;
      layer.ctx.beginPath();
      layer.ctx.arc(x, y, radius, 0, Math.PI * 2);
      layer.ctx.fill();
    }

    layer.ctx.restore();
  }

  private eraseLine(layer: any, x1: number, y1: number, x2: number, y2: number) {
    const dist = Math.hypot(x2 - x1, y2 - y1);
    const step = Math.max(1, (this.editor.toolSettings.eraserSize / 2) * 0.25);
    const steps = Math.ceil(dist / step);

    for (let i = 1; i <= steps; i++) {
      const t = i / steps;
      const x = x1 + (x2 - x1) * t;
      const y = y1 + (y2 - y1) * t;
      this.eraseDot(layer, x, y);
    }
  }

  public renderOverlay(ctx: CanvasRenderingContext2D): void {
    const zoom = this.editor.zoom;
    const panX = this.editor.panX;
    const panY = this.editor.panY;

    const sx = this.currentMouseX * zoom + panX;
    const sy = this.currentMouseY * zoom + panY;
    const radius = (this.editor.toolSettings.eraserSize / 2) * zoom;

    ctx.save();
    ctx.beginPath();
    ctx.arc(sx, sy, radius, 0, Math.PI * 2);
    ctx.strokeStyle = '#ef4444';
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.restore();
  }
}
